import { z } from 'zod';
// FilterOption schema that matches the FilterOption interface
export const FilterOptionSchema = z.object({
    id: z.string(),
    label: z.string(),
    count: z.number(),
    selected: z.boolean(),
    value: z.string().optional(), // For color swatches or other display values
    // New fields for enhanced functionality
    image: z.string().optional(), // For image swatches
    colorCode: z.string().optional(), // For color hex codes
    disabled: z.boolean().optional(), // For unavailable options
    children: z.lazy(() => z.array(FilterOptionSchema)).optional(), // For hierarchical filters
});
// BaseFilter schema that matches the BaseFilter interface
export const BaseFilterSchema = z.object({
    id: z.string(),
    label: z.string(),
    type: z.enum(['text', 'select', 'range', 'color', 'checkbox', 'radio', 'slider', 'swatch', 'hierarchy']),
    options: z.array(FilterOptionSchema).optional(),
    // Range filter specific
    min: z.number().optional(),
    max: z.number().optional(),
    gap: z.number().optional(),
    currentMin: z.number().optional(),
    currentMax: z.number().optional(),
    unit: z.string().optional(), // For price ($), weight (kg), etc.
    // Display configuration
    displayType: z.enum(['list', 'grid', 'dropdown', 'inline']).optional(),
    tooltip: z.string().optional(),
    position: z.number().optional(),
    // Behavior
    multiSelect: z.boolean().optional(),
    searchable: z.boolean().optional(), // Show search box within filter
    sortable: z.boolean().optional(), // Allow sorting of options
    sortType: z.enum(['alphabetical', 'count', 'position', 'custom']).optional(),
    // UI State
    isCollapsible: z.boolean().optional(),
    isCollapsed: z.boolean().optional(),
    showMore: z.boolean().optional(), // For filters with many options
    showMoreLimit: z.number().optional(), // Number of items to show initially
    // Platform-specific metadata
    metadata: z.record(z.any()).optional(),
    platformConfig: z.object({
        unbxd: z.any().optional(),
        algolia: z.any().optional(),
        shopify: z.any().optional(),
        boost: z.any().optional(),
    }).optional(),
});
// Compile-time checks
const _filterCheck = {};
const _filterCheck2 = {};
const _optionCheck = {};
const _optionCheck2 = {};
